export enum ProposalStatus {
  ONGOING = 'ONGOING',
  PENDING_CHECKOUT = 'PENDING_CHECKOUT',
  PENDING_UNDERWRITING = 'PENDING_UNDERWRITING',
  PENDING_EXTRA_QUESTIONNAIRES = 'PENDING_EXTRA_QUESTIONNAIRES',
  PENDING_MODIFICATION_DECISION = 'PENDING_MODIFICATION_DECISION',
  PENDING_EXTERNAL_ACTION = 'PENDING_EXTERNAL_ACTION',
  APPROVED = 'APPROVED',
  REFUSED = 'REFUSED',
  ABANDONED = 'ABANDONED',
}
